import React from "react";
import LogoutWarningModal from "./LogoutWarningModal";
import useSessionTimeout from "../../hooks/useSessionTimeout";

/**
 * SessionTimeoutWarning Component
 * 
 * This component manages session timeout warnings and displays
 * a modal to alert users at 15, 10, and 5 minutes before logout.
 * 
 * Place this component inside the Security provider in App.js
 */
export default function SessionTimeoutWarning() {
  const { showWarning, minutesRemaining, dismissWarning } = useSessionTimeout();

  return (
    <LogoutWarningModal
      isOpen={showWarning}
      minutesRemaining={minutesRemaining}
      handleClose={dismissWarning}
    />
  );
}
